// extracted by mini-css-extract-plugin
module.exports = {"container":"Intro_container__1jXCa","title":"Intro_title__3J3MG","content":"Intro_content__2dLiG"};